import { relationships } from "@rocicorp/zero";
import { project } from "./project";
import { projectResourceLink } from "./project-resource-link";
import { ticket } from "./ticket";
import { ticketFiles } from "./ticket-files";
import { ticketType } from "./ticket-type";

export const ticketRelationships = relationships(ticket, ({ many, one }) => ({
	project: one({
		sourceField: ["projectId"],
		destField: ["id"],
		destSchema: project,
	}),
	ticketType: one({
		sourceField: ["type"],
		destField: ["id"],
		destSchema: ticketType,
	}),
	ticketFiles: many({
		sourceField: ["id"],
		destField: ["ticketId"],
		destSchema: ticketFiles,
	}),
	projectResourceLinks: many({
		sourceField: ["id"],
		destField: ["ticketId"],
		destSchema: projectResourceLink,
	}),
}));
